export default __webpack_public_path__ + "static/media/Chestguard of Black Spite.206a26c8.jpg";